App.prototype.calculateProductPrice = function (form) {
    var formData = form.serialize();
    var productUid = form.find('.product-uid-input').val();
    $.ajax({
        type: 'POST',
        url: App.prototype.apiAddress + 'products/' + productUid + '/calculate',
        dataType: "json",
        data: formData,
        success: function (response) {
            form.find('.price').text( response.calculated_money );
        }
    });
};

$(document).on('change', '.add-product-variation-to-cart-form input:not([type="radio"]), .add-product-variation-to-cart-form select', function () {
    App.prototype.calculateProductPrice($(this).closest('form'));
});

$(document).on('change', '.add-product-variation-to-cart-form input[type="checkbox"]', function () {
    App.prototype.checkBoxChanged($(this)[0].name.match(/\[([a-z0-9]+)]/)[1]);
});
